var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme, withStyles, } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
var TabPanel = function (props) {
    var children = props.children, value = props.value, index = props.index, _a = props.height, height = _a === void 0 ? 'initial' : _a, other = __rest(props, ["children", "value", "index", "height"]);
    return (React.createElement(Box, __assign({ role: "tabpanel", hidden: value !== index, id: "full-width-tabpanel-" + index, "aria-labelledby": "full-width-tab-" + index, style: { height: height } }, other), value === index && children));
};
function a11yProps(index) {
    return {
        id: "full-width-tab-" + index,
        'aria-controls': "full-width-tabpanel-" + index,
    };
}
var useStyles = makeStyles(function (theme) { return ({
    root: {
        backgroundColor: theme.palette.background.paper,
        fontSize: '1.1em',
    },
}); });
var StyleTab = withStyles({
    root: {
        whiteSpace: 'nowrap',
        color: 'white',
        backgroundColor: 'rgb(7, 44, 130)',
        fontSize: '1em',
    },
    selected: {
        backgroundColor: 'whitesmoke',
        fontSize: '1.1em',
        fontWeight: 'bold',
    },
})(Tab);
export var BoostrapSwiTabs = function (props) {
    var classes = useStyles();
    var theme = useTheme();
    var _a = props.width, width = _a === void 0 ? 'initail' : _a, onChange = props.onChange, contentheight = props.contentheight, tabContent = props.tabContent, _b = props.TAB_IDX, value = _b[0], setValue = _b[1];
    var handleChange = function (event, tabIdx) {
        setValue(tabIdx);
        if (onChange) {
            onChange(event, tabIdx);
        }
    };
    var handleChangeIndex = function (index) { return setValue(index); };
    return (React.createElement("div", { className: classes.root, style: { width: width, opacity: 0.95 } },
        React.createElement(AppBar, { position: "static", color: "default" },
            React.createElement(Tabs, { value: value, onChange: handleChange, indicatorColor: "primary", textColor: "primary", variant: "fullWidth", "aria-label": "full width tabs example", TabIndicatorProps: { style: { top: 0 } } }, tabContent.map(function (tab, idx) { return (React.createElement(StyleTab, __assign({ key: idx, label: tab.title }, a11yProps(idx)))); })),
            React.createElement(SwipeableViews, { axis: theme.direction === 'rtl' ? 'x-reverse' : 'x', index: value, onChangeIndex: handleChangeIndex, style: { padding: 24 } }, tabContent.map(function (tab, idx) { return (React.createElement(TabPanel, { key: idx, value: value, index: idx, height: contentheight }, tab.content)); })))));
};
